var $bda0ef313aab3cb4$exports = {};
$bda0ef313aab3cb4$exports = {
    "more": `More items`
};


export {$bda0ef313aab3cb4$exports as default};
//# sourceMappingURL=en-US.mjs.map
